var map = {
	"./client 2.jpg": 4788,
	"./client 3.jpg": 2125,
	"./client 4.jpg": 4537,
	"./client 5.jpg": 2123,
	"./client 6.jpg": 8259,
	"./client 7.jpg": 1403,
	"./client1.jpg": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1918;